import { forEach } from 'lodash'
import ActionTypes from '@constants/action_types.js'
import PhotoPollQueue from '@utils/photo_poll_queue.js'

export function receivePhoto(photo) {
  return (dispatch, getState) => {
    if (photo) {
      pollForPhotoUpdatesIfNeeded(photo, dispatch)
      dispatch({
        type: ActionTypes.RECEIVE_PHOTO,
        payload: photo,
      })
    }
  }
}

export function receivePhotos(photos) {
  return (dispatch, getState) => {
    if (photos) {
      forEach(photos, photo => {
        pollForPhotoUpdatesIfNeeded(photo, dispatch)
      })
      dispatch({
        type: ActionTypes.RECEIVE_PHOTOS,
        payload: photos,
      })
    }
  }
}

function pollForPhotoUpdatesIfNeeded(photo, dispatch) {
  // photo could be in rest style or jsonapi style
  PhotoPollQueue.startPollingIfNeeded(photo, dispatch)
}

export function photoDeleteSuccess(photoId) {
  return {
    type: ActionTypes.PHOTO_DELETE_SUCCESS,
    payload: photoId,
  }
}
